import { MAuswahl } from "../../metamodell";
import { useLayoutEffect, useRef, useState } from "react";

/** Sammlung von setOpen-Funktionen für die InfoBoxen, Nutzung: InfoBox.setInfoBoxOpen[MASSE.Breite](true) */
const infoBoxSetOpenCallbacks: { [key: string]: Function } = {};

/**
 * Öffnet oder schließt die InfoBox mit gegebenem Key
 * @param key Welche InfoBox (AuswahlData.Key)
 * @param shouldOpen neuer Zustand offen?
 */
export function setInfoBoxOpen(key: string, shouldOpen: boolean) {
  infoBoxSetOpenCallbacks[key](shouldOpen);
}

/**
 * Info-Feld für die Auswahl mit ausklappbarem Text
 * @param auswahlData passende Auswahl-Informationen
 * @constructor
 */
export function InfoBox({
  auswahlData,
  small = false,
}: {
  auswahlData: MAuswahl;
  small?: boolean;
}) {
  const [isOpen, setOpen] = useState(false);
  const [translateX, setTranslateX] = useState(0);
  const infoContentRef = useRef(null);

  useLayoutEffect(() => {
    if (!isOpen) {
      setTimeout(() => setTranslateX(0), 1000);
    } else {
      // Schließe alle anderen InfoBoxen:
      Object.entries(infoBoxSetOpenCallbacks).forEach((entry) => {
        const key = entry[0];
        const setOpen = entry[1];
        if (key != auswahlData.Key) setOpen(false);
      });

      // Setze translateX so, dass die InfoBox im aktuellen Content ist
      const infoContentRect = infoContentRef.current.getBoundingClientRect();
      const contentMassRect = document.querySelector(".selectedContent")?.getBoundingClientRect();

      if (!contentMassRect) return;

      if (infoContentRect.left < contentMassRect.left) {
        setTranslateX(contentMassRect.left - infoContentRect.left + 10);
      } else if (infoContentRect.right > contentMassRect.right) {
        setTranslateX(contentMassRect.right - infoContentRect.right - 20);
      }
    }
  }, [isOpen]);

  function setOpenAndUpdateHeight(newIsOpen: boolean) {
    setOpen(newIsOpen);

    setTimeout(APP.updateMenuContainerHeight, 400);
    setTimeout(APP.updateMenuContainerHeight, 800);
    setTimeout(APP.updateMenuContainerHeight, 1200);
  }

  infoBoxSetOpenCallbacks[auswahlData.Key] = setOpenAndUpdateHeight;

  return (
    <div className="infoBox" role="region" aria-label={I18N("aria::Informationsbox")}>
      <button
        className="infoIcon icon-info-circle"
        onClick={() => setOpenAndUpdateHeight(!isOpen)}
        aria-label={I18N("aria::Informationen anzeigen für") + auswahlData.Key}
        aria-expanded={isOpen}
        aria-controls={`infoContent-${auswahlData.Key}`}
        type="button"
      ></button>
      <div
        id={`infoContent-${auswahlData.Key}`}
        className={`infoContent ${isOpen ? "open" : ""} ${small ? "smallTitle" : ""}`}
        ref={infoContentRef}
        style={{ transform: `translate(${translateX}px, -3px)` }}
        role="tooltip"
        aria-hidden={!isOpen}
        aria-live="polite"
      >
        <button
          className="closeX"
          onClick={() => setOpenAndUpdateHeight(false)}
          aria-label={I18N("aria::Informationsbox schließen")}
          type="button"
        >
          <span aria-hidden="true">x</span>
        </button>
        {auswahlData.Bild ? (
          <div className="image">
            <img src={auswahlData.Bild} alt={I18N("aria::Illustration für") + auswahlData.Key} />
          </div>
        ) : null}
        {Commons.isEmpty(auswahlData.Hilfstext) ? null : (
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: auswahlData.Hilfstext }}
            role="document"
          ></div>
        )}
      </div>
    </div>
  );
}
